/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_PlayInputs */

const en_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play`)
};

const fr_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture`)
};

const de_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielen`)
};

const it_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giocare`)
};

const ru_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Играть`)
};

const es_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugar`)
};

const zh_cn2_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`玩`)
};

const ja_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊ぶ`)
};

const hi_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खेल`)
};

const pt_pt2_options_pedal_action_play = /** @type {(inputs: Options_Pedal_Action_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogar`)
};

/**
* | output |
* | --- |
* | "Play" |
*
* @param {Options_Pedal_Action_PlayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_play = /** @type {((inputs?: Options_Pedal_Action_PlayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_PlayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_action_play(inputs)
	if (locale === "de") return de_options_pedal_action_play(inputs)
	if (locale === "it") return it_options_pedal_action_play(inputs)
	if (locale === "ru") return ru_options_pedal_action_play(inputs)
	if (locale === "es") return es_options_pedal_action_play(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_action_play(inputs)
	if (locale === "ja") return ja_options_pedal_action_play(inputs)
	if (locale === "hi") return hi_options_pedal_action_play(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_action_play(inputs)
	return en_options_pedal_action_play(inputs)
});